import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SupplierState } from "src/types/supplier.types";

const initialState: SupplierState = {
  createSupplier: { loading: false, data: null, error: null },
  editSupplier: { loading: false, data: null, error: null },
  supplierList: { loading: false, data: null, error: null },
};

const supplierSlice = createSlice({
  name: "supplier",
  initialState,
  reducers: {
    // Create
    createSupplierRequest: (state, action: PayloadAction<any>) => {
      state.createSupplier.loading = true;
      state.createSupplier.data = null;
      state.createSupplier.error = null;
    },
    createSupplierSuccess: (state, action: PayloadAction<any>) => {
      state.createSupplier.loading = false;
      state.createSupplier.data = action.payload;
    },
    createSupplierError: (state, action: PayloadAction<string>) => {
      state.createSupplier.loading = false;
      state.createSupplier.error = action.payload;
    },
    resetCreateSupplier: (state) => {
      state.createSupplier = { loading: false, data: null, error: null };
    },

    // Edit
    editSupplierRequest: (state, action: PayloadAction<any>) => {
      state.editSupplier.loading = true;
      state.editSupplier.data = null;
      state.editSupplier.error = null;
    },
    editSupplierSuccess: (state, action: PayloadAction<any>) => {
      state.editSupplier.loading = false;
      state.editSupplier.data = action.payload;
    },
    editSupplierError: (state, action: PayloadAction<string>) => {
      state.editSupplier.loading = false;
      state.editSupplier.error = action.payload;
    },
    resetEditSupplier: (state) => {
      state.editSupplier = { loading: false, data: null, error: null };
    },

    // List
    getSupplierListRequest: (
      state,
      action: PayloadAction<{ page: number; limit: number }>
    ) => {
      state.supplierList.loading = true;
      state.supplierList.data = null;
      state.supplierList.error = null;
    },
    getSupplierListSuccess: (state, action: PayloadAction<any>) => {
      state.supplierList.loading = false;
      state.supplierList.data = action.payload;
    },
    getSupplierListError: (state, action: PayloadAction<string>) => {
      state.supplierList.loading = false;
      state.supplierList.error = action.payload;
    },
    resetSupplierList: (state) => {
      state.supplierList = { loading: false, data: null, error: null };
    },
  },
});

export const {
  createSupplierRequest,
  createSupplierSuccess,
  createSupplierError,
  resetCreateSupplier,
  editSupplierRequest,
  editSupplierSuccess,
  editSupplierError,
  resetEditSupplier,
  getSupplierListRequest,
  getSupplierListSuccess,
  getSupplierListError,
  resetSupplierList,
} = supplierSlice.actions;

export default supplierSlice.reducer;
